import React from "react";

import {shortStringWithDayName} from "../../../services/date/formatters";

import useTheme from "@mui/material/styles/useTheme";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import List from "@mui/material/List";
import {ListItem} from "@mui/material";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";


const BookingVariantsList = function ({accommodations, bookingVariants, flexDate}) {
    const theme = useTheme();

    return <>
        <Typography variant='h6' sx={{mt: 1}}>
            Proposta di soggiorno
        </Typography>
        {
            flexDate && <Alert severity="warning">
                Nessuna proposta disponibile in base alle tue tariffe e prezzi per il periodo indicato,
                ma abbiamo trovato delle date alternative!
            </Alert>
        }
        <List>
            {
                bookingVariants.map((bookingVariant, i) => {
                    return <ListItem key={i}>
                        <Stack spacing={1} width="100%" sx={{pl: 1, borderLeft: `3px solid ${theme.palette.success.light}`}}>
                            {
                                bookingVariant.items.map((item, j) => {
                                    const accommodationUnit = accommodations.findAccommodationUnit(item.accommodationType, item.accommodationId);

                                    return <Stack key={j} direction="row" justifyContent="space-between"
                                                  alignItems="center">
                                        <Stack>
                                            <Typography>
                                                {`${accommodationUnit.name} (${accommodationUnit.accommodation.name})`}
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {shortStringWithDayName(item.arrival)} - {shortStringWithDayName(item.departure)}
                                            </Typography>
                                            <Typography variant="body2" color="text.primary">
                                                {item.people !== 1 ? `${item.people} persone` : '1 persona'}
                                            </Typography>
                                        </Stack>
                                        <Typography>{item.getPrice()}€</Typography>
                                    </Stack>
                                })
                            }
                            {
                                bookingVariant.items.length > 1 && <>
                                    <Divider/>
                                    <Typography fontWeight={500} align="right">
                                        Tot: {bookingVariant.getPrice()} €
                                    </Typography>
                                </>
                            }
                        </Stack>
                    </ListItem>
                })
            }
        </List>
    </>
}

export default BookingVariantsList;